import { useState } from "react";
import "./BookingForm.css";

export default function BookingForm({ availableTimes, dispatch, submitForm }) {
  // Declare the states
  const [bookDate, setBookDate] = useState("");
  const [bookTime, setBookTime] = useState("17:00");
  const [guests, setGuests] = useState(1);
  const [occasion, setOccasion] = useState("birthday");
  const [errors, setErrors] = useState({
    bookDate: "",
    bookTime: "",
    guests: "",
  });

  // Handling the date
  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setBookDate(selectedDate);
    dispatch({ type: "FETCH_TIMES", payload: selectedDate });
  };

  // Handling the submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      bookDate,
      bookTime,
      guests,
      occasion,
    };
    console.log("Reservation Submitted:", formData);
    if (validateForm() && submitForm) {
      submitForm(formData);
    }
  };

  // Validations
  const validateForm = () => {
    const newErrors = {};

    let selectedDate = null;
    if (bookDate) {
      const [year, month, day] = bookDate.split("-").map(Number);
      selectedDate = new Date(year, month - 1, day);
    }

    // Date Validation
    if (!bookDate) {
      newErrors.bookDate = "Please select a date.";
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        newErrors.bookDate = "Date cannot be less than today.";
      }
    }

    // Time Validation
    if (!bookTime) {
      newErrors.bookTime = "Please select a time.";
    } else if (!availableTimes.includes(bookTime)) {
      newErrors.bookTime = "The selected time is invalid.";
    } else if (selectedDate) {
      const today = new Date();
      if (selectedDate.toDateString() === today.toDateString()) {
        const [hours, minutes] = bookTime.split(":").map(Number);
        const selectedDateTime = new Date(selectedDate);
        selectedDateTime.setHours(hours, minutes, 0, 0);
        if (selectedDateTime < today) {
          newErrors.bookTime = "Selected time cannot be in the past.";
        }
      }
    }

    // Guests Validation
    if (guests < 1 || guests > 10) {
      newErrors.guests = "The guests must be between 1 and 10.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "grid",
        maxWidth: "500px",
        width: "100%",
        gap: "20px",
        padding: "2rem",
      }}
    >
      {/* Date picker */}
      <label htmlFor="res-date">Choose date</label>
      <input
        type="date"
        id="res-date"
        value={bookDate}
        onChange={handleDateChange}
        aria-invalid={errors.bookDate ? "true" : "false"}
        aria-describedby={errors.bookDate ? "res-date-error" : undefined}
        required
      />
      {errors.bookDate && (
        <span className="error-message" id="res-date-error" role="alert">
          {errors.bookDate}
        </span>
      )}

      {/* Time picker */}
      <label htmlFor="res-time">Choose time</label>
      <select
        id="res-time"
        value={bookTime}
        onChange={(e) => setBookTime(e.target.value)}
        aria-invalid={errors.bookTime ? "true" : "false"}
        aria-describedby={errors.bookTime ? "res-time-error" : undefined}
        required
      >
        {availableTimes.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
      {errors.bookTime && (
        <span className="error-message" id="res-time-error" role="alert">
          {errors.bookTime}
        </span>
      )}

      {/* Amount of guests */}
      <label htmlFor="guests">Number of guests</label>
      <input
        type="number"
        placeholder="1"
        min="1"
        max="10"
        id="guests"
        value={guests}
        onChange={(e) => setGuests(Number(e.target.value))}
        aria-invalid={errors.guests ? "true" : "false"}
        aria-describedby={errors.guests ? "guests-error" : undefined}
        required
      />
      {errors.guests && (
        <span className="error-message" id="guests-error" role="alert">
          {errors.guests}
        </span>
      )}

      {/* Occasion */}
      <label htmlFor="occasion">Occasion</label>
      <select
        id="occasion"
        value={occasion}
        onChange={(e) => setOccasion(e.target.value)}
        aria-invalid={errors.occasion ? "true" : "false"}
        aria-describedby={errors.occasion ? "occasion-error" : undefined}
        required
      >
        <option value="birthday">Birthday</option>
        <option value="anniversary">Anniversary</option>
      </select>
      {errors.occasion && (
        <span className="error-message" id="occasion-error" role="alert">
          {errors.occasion}
        </span>
      )}

      {/* Submit button */}
      <button type="submit" className="button-primary">
        Make Your reservation
      </button>
    </form>
  );
}
